import React, { useContext, useState } from "react";
import { useDispatch } from "react-redux";
import { Timeout } from "../../functions/functions";
import { ExpenseInterface, ShowExpenseContext } from "./types";
import { DeleteExpenseApi } from "../../redux/expense/expenseApiCalls";
import ShowErrorMsg from "../../HtmlComponents/ShowErrorMsg";
import ButtonsForm from "../../HtmlComponents/ButtonsForm";

interface props {
  modal: boolean,
  toggle: any,
  selectedExpense: ExpenseInterface
}

const DeleteExpense = ({ modal, toggle, selectedExpense }: props) => {
  const [errors, setErrors] = useState([]);
  const dispatch: any = useDispatch();
  const { setShowSuccessMsg } = useContext(ShowExpenseContext)
  const [loading, setLoading] = useState(false)

  const handleSubmitExpense = async (e: any) => {
    e.preventDefault();
    setLoading(true)
    try {
      const response: any = await dispatch(DeleteExpenseApi(selectedExpense._id));
      if (response === true) {
        toggle();
        setShowSuccessMsg(true);
        setTimeout(() => setShowSuccessMsg(false), Timeout);
        setErrors([]);
      } else {
        setErrors(response);
      }
    } finally {
      setLoading(false)
    }
  };

  return (
    <div>
      {modal && (
        <>
          <div className="fixed inset-0 z-10 overflow-y-auto">
            <div
              className="fixed inset-0 w-full h-full bg-black opacity-40"
              onClick={toggle}
            ></div>
            <div className="flex items-center min-h-screen px-4 py-8">
              <div className="relative w-full max-w-lg p-4 mx-auto bg-white rounded-md shadow-lg">
                <div className="mt-3">
                  {/* Start Modal Body */}
                  <form
                    className="mt-2 sm:ml-4 sm:text-left"
                    onSubmit={handleSubmitExpense}
                  >
                    <ShowErrorMsg errors={errors} setErrors={setErrors} />
                    <ButtonsForm loading={loading} typeBtn="Supprimer" toggle={toggle} />
                  </form>
                  {/* End Modal Body */}
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default DeleteExpense;
